module.exports = __webpack_public_path__ + "static/media/construccion.652ddbf2.png";